import { TableCell, TableRow } from "@mui/material";

interface IntegrationConfigurationsAndMessagesHalfDataTableRowProps {
  title: string;
  value: React.ReactNode;
}

export function IntegrationConfigurationsAndMessagesHalfDataTableRow({
  title,
  value,
}: IntegrationConfigurationsAndMessagesHalfDataTableRowProps) {
  return (
    <TableRow>
      <TableCell
        width="50%"
        sx={{ py: 1, pl: 0, color: "text.secondary", verticalAlign: "top" }}
      >
        {title}
      </TableCell>
      <TableCell
        sx={{
          py: 1,
          pl: 0,
        }}
      >
        {value}
      </TableCell>
    </TableRow>
  );
}
